import { useState, useRef } from 'react'

export default () => {
    const [show, setShow] = useState(false)
    const ref = useRef(null)

    return {
        ref, setShow, show,
    }
}